var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.91458C19 9.25578 18.9466 8.59342 18.8326 7.94531H9.69141V11.6773H14.9262C14.7089 12.8809 14.011 13.9457 12.9889 14.6223V17.0438H16.112C17.9459 15.3559 19 12.8631 19 9.91458Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69174 19.3836C12.3056 19.3836 14.5099 18.5254 16.1159 17.044L12.9928 14.6225C12.1239 15.2136 11.0022 15.5484 9.6953 15.5484C7.16695 15.5484 5.0232 13.8426 4.25401 11.5493H1.03125V14.0456C2.67646 17.3182 6.02741 19.3836 9.69174 19.3836V19.3836Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25012 11.5492C3.84416 10.3456 3.84416 9.04222 4.25012 7.83859V5.34229H1.03093C-0.343642 8.08074 -0.343642 11.3071 1.03093 14.0455L4.25012 11.5492V11.5492Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69174 3.83591C11.0734 3.81455 12.4088 4.33446 13.4095 5.28882L16.1764 2.52188C14.4244 0.876673 12.099 -0.0278354 9.69174 0.000653093C6.02741 0.000653093 2.67646 2.06607 1.03125 5.34224L4.25045 7.83854C5.01607 5.54166 7.16339 3.83591 9.69174 3.83591V3.83591Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.69e61032324d013210893cb2348614e4.svg";
export { ForwardRef as ReactComponent };